import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Headers, Http, RequestOptions } from "@angular/http";
import { Subscription } from "rxjs/Subscription";
import { ResultDialogComponent } from "../result-dialog/result-dialog.component";

import { AuthGuardService, UserService, LoadingService } from "@core/services";

import { CreditCardIframeComponent } from "../credit-card-iframe/credit-card-iframe.component";
import { CreditCardComponent } from "@app/component/credit-card/credit-card.component";
import { Constants } from "../../constants";

@Component({
  selector: "app-add-credit-card-dialog",
  templateUrl: "./add-credit-card-dialog.component.html",
  styleUrls: ["./add-credit-card-dialog.component.css"],
})
export class AddCreditCardDialogComponent implements OnInit, OnDestroy {
  @ViewChild(CreditCardIframeComponent)
  creditCard: CreditCardIframeComponent;

  @ViewChild(CreditCardComponent)
  creditCardCAD: CreditCardComponent;

  public passId: number;
  addCreditCard: FormGroup;
  public user: any;
  private currencyType: number;
  private subscription: Subscription;
  terminals = [];
  hsns = [];
  private hsn: string;
  private sessionKey: string;
  private loading: boolean = false;
  public rawCard: string;
  public isAmex: boolean;

  constructor(
    public dialogRef: MatDialogRef<AddCreditCardDialogComponent>,
    private authGuard: AuthGuardService,
    private _http: Http,
    private _service: UserService,
    private _fb: FormBuilder,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.subscription = this._service.getUser().subscribe((user) => {
      this.user = user;
      this.currencyType = this.user.accountSummaryArray[
        this.user.accountIndex
      ].ProgramType;
    });
    this.addCreditCard = this._fb.group({
      creditCard: this._fb.group({
        CardNumber: new FormControl("", Validators.required),
        ExpireMonth: new FormControl("", Validators.required),
        ExpireYear: new FormControl("", Validators.required),
        CVV: new FormControl("", Validators.required),
      }),
    });

    //Check if user is customer service, if so load cc terminal serials
    if (this.user.isCustomerService) {
      this._http
        .get(
          Constants.NEXPRESS_ENDPOINT + "terminals/GetSerials",
          this.setAuthenticatedHeaders()
        )
        .subscribe(
          (result: any) => {
            console.log(result);
            if (result._body) {
              JSON.parse(result._body).response.forEach((element) => {
                console.log(element);
                var split = element.split("-");
                this.hsns.push(split[split.length - 1]);
                console.log(split);
                this.terminals.push(
                  split[0] +
                    "-" +
                    split[split.length - 1].substr(
                      split[split.length - 1].length - 4
                    )
                );
              });
              //this.terminals = JSON.parse(result._body).response;
              console.log(this.terminals);
            }
          },
          (err) => console.log(err)
        );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(): void {
    let cardData = this.setupAddCardData();

    if (!cardData.CardNumber && cardData && cardData.CardNumber.length <= 0) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: "Please enter a valid card number.",
          alertType: "danger",
          title: "Card number is invalid",
        },
      });
    }

    if (cardData.CVV === "") {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: "Please enter a valid CVV code.",
          alertType: "danger",
          title: "CVV code is missing",
        },
      });
    } else if (cardData.CVV.length < 3) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: "Please enter a valid CVV code",
          alertType: "danger",
          title: "CVV number is too short",
        },
      });
    } else if (this.isAmex && cardData.CVV.length < 4) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message:
            "CVV codes for American Express cards are 4 digits long and are displayed on the front of your card. Please make sure you have entered your information correctly.",
          alertType: "danger",
          title: "Invalid AmEx CVV",
        },
      });
    } else {
      if (cardData.CVV === "9999") {
        //console.log("overriding cvv");
        cardData.CVV = "";
      }

      this.authGuard
        .authenticatedPost("portfolios/AddCreditCard", cardData)
        .subscribe(
          (result) => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.loading = false;
            let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                message: error,
                alertType: "danger",
                title: "Failed to Add Credit Card",
              },
            });
          }
        );
    }
  }

  setupAddCardData() {
    // this (cardFromComponent) was done because context menu (right click) paste wasn't
    // updating this.rawCard so I used a ViewChild to get the updated value from
    // inside the child component.
    // Should look into reworking this, has some funky directive component interaction.
    //const cardFromComponent = this.creditCard.rawCard;

    const creditCardData: any = {};
    const currentCustomer = this.user.customerIdArray[this.user.customerIndex];
    const billingAddress = currentCustomer.BillingAddress;

    // if (this.currencyType === 10 || this.currencyType === 19) {
    //   creditCardData.CardNumber = this.creditCardCAD.creditCardForm.controls.CardNumber.value.replace(/ /g, "");
    //   creditCardData.ExpireMonth = this.creditCardCAD.creditCardForm.controls.ExpireMonth.value;
    //   creditCardData.ExpireYear = this.creditCardCAD.creditCardForm.controls.ExpireYear.value;
    //   creditCardData.CVV = this.creditCardCAD.creditCardForm.controls.CVV.value;
    // } else {

    //if(!this.user.isCustomerService){
    creditCardData.CardNumber = this.creditCard.creditCardForm.controls.CardNumber.value.replace(
      / /g,
      ""
    );
    creditCardData.ExpireMonth = this.creditCard.creditCardForm.controls.ExpireMonth.value;
    creditCardData.ExpireYear = this.creditCard.creditCardForm.controls.ExpireYear.value;
    creditCardData.CVV = this.creditCard.creditCardForm.controls.CVV.value;
    //}
    //}

    creditCardData.CustomerId = this.getCustomerId();
    creditCardData.NameOnCard = this.getCustomerName();
    creditCardData.ZipPostal = billingAddress.PostalCode;
    creditCardData.Address = billingAddress.Street;
    creditCardData.IsPrimary = true;
    creditCardData.UpdateUser = this.user.userName;
    creditCardData.AccountId = this.user.accountSummaryArray[
      this.user.accountIndex
    ].id;

    return creditCardData;
  }

  connectToTerminal(hsn) {
    this.loading = true;
    this.hsn = this.hsns[this.terminals.indexOf(hsn)];
    console.log(this.hsns);
    console.log(this.hsn);
    console.log("button click: " + hsn);
    this.authGuard
      .authenticatedPost("/terminals/ConnectTerminal", {
        Hsn: this.hsn.toString(),
      })
      .subscribe(
        (result: any) => {
          console.log(result);
          if (result.StatusCode && result.StatusCode < 400) {
            var headers = result.Headers;
            var sessionKey = headers.find(
              (x) => x.Name == "X-CardConnect-SessionKey"
            );
            sessionKey = sessionKey.Value.split(";")[0];
            console.log(sessionKey);
            this.sessionKey = sessionKey;
            this.readManual(this.hsn.toString(), sessionKey);
          } else {
            if (result.ErrorMessage) {
              console.log(result.ErrorMessage);
              this.dialog.open(ResultDialogComponent, {
                data: {
                  message: result.ErrorMessage,
                  alertType: "danger",
                  title: "Terminal Connection Error",
                },
              });
            } else {
              this.dialog.open(ResultDialogComponent, {
                data: {
                  message: result.ErrorMessage,
                  alertType: "danger",
                  title: "Could not complete bolt service connection.",
                },
              });
            }
          }
        },
        (err) => {
          console.log(err);
          this.dialog.open(ResultDialogComponent, {
            data: {
              message: err,
              alertType: "danger",
              title: "Terminal Connection Error",
            },
          });
        }
      );
  }

  readManual(hsn, sessionKey) {
    this.authGuard
      .authenticatedPost("/terminals/ReadManual", {
        Hsn: hsn,
        SessionKey: sessionKey,
      })
      .subscribe(
        (res: any) => {
          console.log(res);
          if (res.Content && res.StatusCode < 400) {
            var contentJson = JSON.parse(res.Content);
            let cardData = this.setupAddCardData();
            cardData.CardNumber = contentJson.token;
            cardData.Token = contentJson.token;
            cardData.ExpireMonth = contentJson.expiry.substring(0, 2);
            cardData.ExpireYear = contentJson.expiry.substring(2, 4);
            cardData.CVV = "9999";
            console.log(cardData);

            //Send card data for storage

            this.authGuard
              .authenticatedPost("/portfolios/AddCreditCard", cardData)
              .subscribe(
                (result) => {
                  this.dialogRef.close(true);
                },
                (error) => {
                  let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                      message: error,
                      alertType: "danger",
                      title: "Unable to Save Card",
                    },
                  });
                }
              );
          } else {
            if (res.Content) {
              var contentJson = JSON.parse(res.Content);
              if (contentJson.errorMessage && this.loading == true) {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                  data: {
                    message: contentJson.errorMessage,
                    alertType: "danger",
                    title: "Read Card Error",
                  },
                });
              }
            } else {
              if (res.ErrorMessage) {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                  data: {
                    message: res.ErrorMessage,
                    alertType: "danger",
                    title: "Read Card Timeout",
                  },
                });
              }
            }
            this.loading = false;
          }
        },
        (err) => {
          console.log(err);
          this.dialog.open(ResultDialogComponent, {
            data: {
              message: err,
              alertType: "danger",
              title: "Terminal Connection Error",
            },
          });
        }
      );
  }

  cancel() {
    if (this.loading && this.hsn && this.sessionKey) {
      this.authGuard
        .authenticatedPost("/terminals/Cancel", {
          Hsn: this.hsn,
          SessionKey: this.sessionKey,
        })
        .subscribe((result) => {
          console.log("Card Read Canceled.");
        });
    }
    this.loading = false;
  }

  private getCustomerId() {
    return this.user.customerIdArray[this.user.customerIndex].Id;
  }

  private getCustomerName() {
    return this.user.customerIdArray[this.user.customerIndex].BillingAddress
      .NameOnCard;
  }

  private setAuthenticatedHeaders() {
    const token = localStorage.getItem(Constants.TOKEN)
      ? localStorage.getItem(Constants.TOKEN)
      : sessionStorage.getItem(Constants.TOKEN);
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return new RequestOptions({ headers: headers });
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/add-credit-card-dialog/add-credit-card-dialog.component.ts